"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EImgType = exports.EIconType = exports.EWithdrawStatusCode = void 0;
var EWithdrawStatusCode;
(function (EWithdrawStatusCode) {
    EWithdrawStatusCode[EWithdrawStatusCode["ManyTime"] = -38] = "ManyTime";
    EWithdrawStatusCode[EWithdrawStatusCode["PagsmileDocumentId"] = -35] = "PagsmileDocumentId";
    EWithdrawStatusCode[EWithdrawStatusCode["InstapaysNameSurname"] = -33] = "InstapaysNameSurname";
    EWithdrawStatusCode[EWithdrawStatusCode["PaparaNo"] = -32] = "PaparaNo";
    EWithdrawStatusCode[EWithdrawStatusCode["PaparaEmpty"] = -31] = "PaparaEmpty";
    EWithdrawStatusCode[EWithdrawStatusCode["InvalidBonus"] = -30] = "InvalidBonus";
    EWithdrawStatusCode[EWithdrawStatusCode["PagsmileAccountType2"] = -29] = "PagsmileAccountType2";
    EWithdrawStatusCode[EWithdrawStatusCode["PagsmileAccountType1"] = -28] = "PagsmileAccountType1";
    EWithdrawStatusCode[EWithdrawStatusCode["PagsmileAccountType0"] = -27] = "PagsmileAccountType0";
    EWithdrawStatusCode[EWithdrawStatusCode["PagsmileAccount"] = -26] = "PagsmileAccount";
    EWithdrawStatusCode[EWithdrawStatusCode["PagsmileAccountDigit"] = -25] = "PagsmileAccountDigit";
    EWithdrawStatusCode[EWithdrawStatusCode["PagsmileBranche"] = -24] = "PagsmileBranche";
    EWithdrawStatusCode[EWithdrawStatusCode["PagsmileBankCode"] = -23] = "PagsmileBankCode";
    EWithdrawStatusCode[EWithdrawStatusCode["PagsmileDocumentType"] = -22] = "PagsmileDocumentType";
    EWithdrawStatusCode[EWithdrawStatusCode["PaykassmaTransactionIsAlreadyProcess"] = -21] = "PaykassmaTransactionIsAlreadyProcess";
    EWithdrawStatusCode[EWithdrawStatusCode["ClientBan"] = -20] = "ClientBan";
    EWithdrawStatusCode[EWithdrawStatusCode["OperatorInvalidResponse"] = -18] = "OperatorInvalidResponse";
    EWithdrawStatusCode[EWithdrawStatusCode["PayazoftTransactionIsAlreadyProcess"] = -17] = "PayazoftTransactionIsAlreadyProcess";
    EWithdrawStatusCode[EWithdrawStatusCode["PayazoftTransactionNotFound"] = -16] = "PayazoftTransactionNotFound";
    EWithdrawStatusCode[EWithdrawStatusCode["ClientNotIdentify"] = -15] = "ClientNotIdentify";
    EWithdrawStatusCode[EWithdrawStatusCode["ActiveBonus"] = -14] = "ActiveBonus";
    EWithdrawStatusCode[EWithdrawStatusCode["ExceededBalance"] = -13] = "ExceededBalance";
    EWithdrawStatusCode[EWithdrawStatusCode["Max"] = -12] = "Max";
    EWithdrawStatusCode[EWithdrawStatusCode["Min"] = -11] = "Min";
    EWithdrawStatusCode[EWithdrawStatusCode["OperatorResponseError"] = -10] = "OperatorResponseError";
    EWithdrawStatusCode[EWithdrawStatusCode["ResponsibleDate"] = -9] = "ResponsibleDate";
    EWithdrawStatusCode[EWithdrawStatusCode["ResponsibleRefill"] = -8] = "ResponsibleRefill";
    EWithdrawStatusCode[EWithdrawStatusCode["ChannelNotSupportMethod"] = -7] = "ChannelNotSupportMethod";
    EWithdrawStatusCode[EWithdrawStatusCode["ClientNotRolled"] = -6] = "ClientNotRolled";
    EWithdrawStatusCode[EWithdrawStatusCode["ClientNotDeposit"] = -5] = "ClientNotDeposit";
    EWithdrawStatusCode[EWithdrawStatusCode["ClientCurrency"] = -4] = "ClientCurrency";
    EWithdrawStatusCode[EWithdrawStatusCode["Channel"] = -3] = "Channel";
    EWithdrawStatusCode[EWithdrawStatusCode["PaymentCurrency"] = -2] = "PaymentCurrency";
    EWithdrawStatusCode[EWithdrawStatusCode["Success"] = 0] = "Success";
    EWithdrawStatusCode[EWithdrawStatusCode["Postponed"] = 1] = "Postponed";
    EWithdrawStatusCode[EWithdrawStatusCode["NeedOpenApk"] = 7] = "NeedOpenApk";
    EWithdrawStatusCode[EWithdrawStatusCode["QrLink"] = 8] = "QrLink";
    EWithdrawStatusCode[EWithdrawStatusCode["QrLinkCode"] = 9] = "QrLinkCode";
    EWithdrawStatusCode[EWithdrawStatusCode["Iframe"] = 10] = "Iframe";
    EWithdrawStatusCode[EWithdrawStatusCode["BarLinkCode"] = 11] = "BarLinkCode";
    EWithdrawStatusCode[EWithdrawStatusCode["PayoutUrl"] = 12] = "PayoutUrl";
})(EWithdrawStatusCode || (exports.EWithdrawStatusCode = EWithdrawStatusCode = {}));
var EIconType;
(function (EIconType) {
    EIconType[EIconType["Error"] = 0] = "Error";
    EIconType[EIconType["Wait"] = 1] = "Wait";
    EIconType[EIconType["Success"] = 2] = "Success";
})(EIconType || (exports.EIconType = EIconType = {}));
var EImgType;
(function (EImgType) {
    EImgType[EImgType["Money"] = 0] = "Money";
    EImgType[EImgType["RedCoin"] = 1] = "RedCoin";
    EImgType[EImgType["Pack"] = 2] = "Pack";
})(EImgType || (exports.EImgType = EImgType = {}));
